import {
    memberFetch,
    memberProfileFetch,
    fetchFollowers,
    fetchFollowees,
    fetchBlacklistedUsers,
    fetchFavoriteContributors,
    fetchMemberContributions,
    fetchFavoriteContributionsList,
    fetchMemberGifts,
    fetchMemberGuestbookList
} from '../store/member/memberSlice'
import isEmpty from 'lodash/isEmpty'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkAuth = async (store: any, force?: boolean) => {
    if ((!store.getState().member.user && !store.getState().member.triedLoad) || force)
        await store.dispatch(memberFetch({}))
}

// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// export const loadMemberProfile = async (store: any) => {
//     await store.dispatch(memberFetch())
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMember = async (store: any) => {
    await store.dispatch(memberFetch({})).then(async () => {
        const memberState = store.getState().member
        const updatedUser = memberState.user
        if (updatedUser) {
            // if (isEmpty(memberState.userPhotos)) await store.dispatch(memberProfileFetch({ nick: updatedUser.nick }))
            if (isEmpty(memberState.followers)) await store.dispatch(fetchFollowers({ p: 1 }))
            if (isEmpty(memberState.userGuestbook))
                await store.dispatch(fetchMemberGuestbookList({ nick: memberState.user.nick, p: 1 }))
            if (isEmpty(memberState.followees)) await store.dispatch(fetchFollowees({ p: 1 }))
            if (isEmpty(memberState.favoriteContributors)) await store.dispatch(fetchFavoriteContributors({ p: 1 }))
            if (isEmpty(memberState.blacklist)) await store.dispatch(fetchBlacklistedUsers({ p: 1 }))
            if (isEmpty(memberState.favoriteContributions))
                await store.dispatch(fetchFavoriteContributionsList({ p: 1 }))
            if (isEmpty(memberState.contributionsList))
                await store.dispatch(fetchMemberContributions({ user_id: updatedUser.id, p: 1 }))
            if (isEmpty(memberState.virtualGifts)) await store.dispatch(fetchMemberGifts({ p: 1 }))
        }
    })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberProfile = async (store: any) => {
    // const updatedUser = store.getState().member.user
    // if (updatedUser && isEmpty(store.getState().member.userPhotos))
    //     await store.dispatch(memberProfileFetch({ nick: updatedUser.nick }))
    await store.dispatch(memberFetch({ full: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberFollowers = async (store: any) => {
    if (isEmpty(store.getState().member.followers)) await store.dispatch(fetchFollowers({ p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberFollowees = async (store: any) => {
    if (store.getState().member.user && isEmpty(store.getState().member.followees))
        await store.dispatch(fetchFollowees({ p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberFavoriteContributors = async (store: any) => {
    if (store.getState().member.user && isEmpty(store.getState().member.favoriteContributors))
        await store.dispatch(fetchFavoriteContributors({ p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberBlacklistedUsers = async (store: any) => {
    if (store.getState().member.user && isEmpty(store.getState().member.blacklist))
        await store.dispatch(fetchBlacklistedUsers({ p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberFavoriteContributionsList = async (store: any) => {
    if (store.getState().member.user && isEmpty(store.getState().member.favoriteContributions))
        await store.dispatch(fetchFavoriteContributionsList({ p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberContributions = async (store: any) => {
    const updatedUser = store.getState().member.user
    if (updatedUser && isEmpty(store.getState().member.contributionsList))
        await store.dispatch(fetchMemberContributions({ user_id: updatedUser.id, p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberGifts = async (store: any) => {
    if (store.getState().member.user && isEmpty(store.getState().member.virtualGifts))
        await store.dispatch(fetchMemberGifts({ p: 1 }))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMemberGuestBook = async (store: any) => {
    const nick = store.getState().member.user.nick || ''
    if (store.getState().member.user && isEmpty(store.getState().member.userGuestbook))
        await store.dispatch(fetchMemberGuestbookList({ nick, p: 1 }))
}
